"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSchemaFormStepPage = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const standard_1 = require("react-hook-schema/standard");
const react_bootstrap_1 = require("react-bootstrap");
require("./SchemaFormStep.scss");
require("../SchemaFormPage/SchemaForm.scss");
const url_1 = require("utils/url");
const hooks_1 = require("common/hooks");
const components_1 = require("utils/components");
const SchemaFormPage_1 = require("../SchemaFormPage");
const SchemaFormStepPageInternal = ({ schemaComponents, data, parameter, loading, readOnly, editModeEnabled, header, }) => {
    var _a, _b, _c, _d, _e, _f;
    const [currentStep, setCurrentStep] = (0, react_1.useState)(0);
    const [isPending, setIsPending] = (0, react_1.useState)(false);
    const errorModal = (0, standard_1.useErrorModal)();
    const { copy, paste } = (0, standard_1.useCopyPaste)({
        objectType: (_a = parameter.clipboard) === null || _a === void 0 ? void 0 : _a.objectType,
        ignoreKeys: (_b = parameter.clipboard) === null || _b === void 0 ? void 0 : _b.ignoreKeys,
    });
    const confirm = (0, standard_1.useConfirm)();
    const accessorRef = react_1.default.useRef(null);
    const searchParamAccessor = (0, url_1.useSearchParamAccessor)();
    const { value: editMode, setValue: setEditMode } = (0, hooks_1.useFieldAccessor)(searchParamAccessor, "edit");
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { steps } = parameter, rest = __rest(parameter, ["steps"]);
    const currentStepData = steps[currentStep];
    const _onNextStep = currentStep < steps.length - 1 && !!currentStepData.next
        ? (value) => __awaiter(void 0, void 0, void 0, function* () {
            var _g;
            if (((_g = currentStepData.next) === null || _g === void 0 ? void 0 : _g.condition) &&
                !currentStepData.next.condition(value)) {
                alert("条件を満たしていません。入力内容を確認してください。");
                return;
            }
            setCurrentStep(Math.min(currentStep + 1, steps.length - 1));
        })
        : undefined;
    const onNextStep = _onNextStep
        ? (value) => __awaiter(void 0, void 0, void 0, function* () {
            var _h, _j;
            if ((_h = currentStepData.next) === null || _h === void 0 ? void 0 : _h.confirm) {
                const result = yield confirm({
                    message: currentStepData.next.confirm,
                });
                if (!result)
                    return;
            }
            let validate = true;
            if ((_j = currentStepData.next) === null || _j === void 0 ? void 0 : _j.handler) {
                const res = yield currentStepData.next.handler(value, accessorRef);
                if (res === false) {
                    validate = false;
                }
            }
            if (validate) {
                yield _onNextStep(value);
            }
        })
        : undefined;
    const onBackStep = currentStep > 0
        ? () => __awaiter(void 0, void 0, void 0, function* () {
            setCurrentStep((prev) => Math.max(currentStep - 1, 0));
            return;
        })
        : undefined;
    const currentParameter = Object.assign(Object.assign(Object.assign({}, rest), currentStepData), { back: onBackStep && steps.length !== currentStep + 1
            ? {
                title: "もどる",
                handler: onBackStep,
            }
            : undefined, backPath: onBackStep ? undefined : rest.backPath, next: onNextStep
            ? {
                title: ((_c = currentStepData.next) === null || _c === void 0 ? void 0 : _c.title) || "次へ",
                condition: (_d = currentStepData.next) === null || _d === void 0 ? void 0 : _d.condition,
                handler: onNextStep,
            }
            : undefined });
    const clickDelete = () => __awaiter(void 0, void 0, void 0, function* () {
        var _k, _l, _m, _o, _p;
        if (((_k = parameter.remove) === null || _k === void 0 ? void 0 : _k.confirm) !== false) {
            const result = yield confirm({
                message: ((_l = parameter.remove) === null || _l === void 0 ? void 0 : _l.confirm) || "削除しますか？",
            });
            if (!result)
                return;
        }
        try {
            setIsPending(true);
            yield ((_o = (_m = parameter.remove) === null || _m === void 0 ? void 0 : _m.handler) === null || _o === void 0 ? void 0 : _o.call(_m));
            const path = ((_p = parameter.remove) === null || _p === void 0 ? void 0 : _p.path) || parameter.backPath;
            path && navigate(path);
        }
        catch (e) {
            errorModal({
                error: e,
                internalMessage: "Error while removing",
            });
        }
        finally {
            setIsPending(false);
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Modal, { show: isPending },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, null,
                react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "\u8AAD\u307F\u8FBC\u307F\u4E2D\u3067\u3059")),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                react_1.default.createElement("p", null, "\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044"))),
        react_1.default.createElement(components_1.PageHeader, { title: (_e = parameter.title) !== null && _e !== void 0 ? _e : "", breadCrumbConfigs: parameter.breadcrumbConfigs }, ((_f = parameter.header) === null || _f === void 0 ? void 0 : _f.isStacked) ||
            (parameter === null || parameter === void 0 ? void 0 : parameter.clipboard) ||
            editModeEnabled ? (react_1.default.createElement(react_bootstrap_1.Stack, { direction: "horizontal", gap: 3 },
            react_1.default.createElement("h2", { className: "subtitle" }, parameter.subtitle),
            react_1.default.createElement("div", { className: "ms-auto d-flex" },
                editMode && parameter.remove && (react_1.default.createElement(components_1.Button, { style: { marginLeft: "5px" }, variant: "danger", onClick: clickDelete, "data-tooltip-id": "tooltip", "data-tooltip-content": "\u524A\u9664" },
                    react_1.default.createElement("i", { className: "mdi mdi-delete" }))),
                !loading &&
                    parameter.clipboard &&
                    !parameter.clipboard.isDisabled && (react_1.default.createElement(components_1.Button, { style: { marginLeft: "5px" }, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        var _q;
                        copy(yield ((_q = accessorRef.current) === null || _q === void 0 ? void 0 : _q.get()));
                    }), variant: "outline-secondary", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u30B3\u30D4\u30FC" },
                    react_1.default.createElement("i", { className: "mdi mdi-content-copy" }))),
                !loading &&
                    parameter.clipboard &&
                    !parameter.clipboard.isDisabled &&
                    ((editModeEnabled && editMode) || !editModeEnabled) && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(components_1.Button, { style: { marginLeft: "5px" }, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                            var _r, _s, _t, _u;
                            const currentValue = (_r = accessorRef.current) === null || _r === void 0 ? void 0 : _r.get();
                            const retainedValue = Object.fromEntries(((_t = (_s = parameter.clipboard) === null || _s === void 0 ? void 0 : _s.retainKeys) === null || _t === void 0 ? void 0 : _t.map((key) => [
                                key,
                                currentValue === null || currentValue === void 0 ? void 0 : currentValue[key],
                            ])) || []);
                            const clipBoardData = yield paste();
                            if (!clipBoardData)
                                return;
                            (_u = accessorRef.current) === null || _u === void 0 ? void 0 : _u.set(Object.assign(Object.assign({}, clipBoardData), retainedValue));
                        }), variant: "outline-secondary", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u8CBC\u308A\u4ED8\u3051" },
                        react_1.default.createElement("i", { className: "mdi mdi-content-paste" })))),
                editModeEnabled && editMode && (react_1.default.createElement(components_1.Button, { style: { marginLeft: "5px" }, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        var _v;
                        copy(yield ((_v = accessorRef.current) === null || _v === void 0 ? void 0 : _v.get()));
                    }), variant: "primary", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u30B3\u30D4\u30FC" },
                    react_1.default.createElement("i", { className: "mdi mdi-content-copy" }))),
                !loading &&
                    parameter.clipboard &&
                    !parameter.clipboard.isDisabled &&
                    ((editModeEnabled && editMode) || !editModeEnabled) && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(components_1.Button, { style: { marginLeft: "5px" }, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                            var _w, _x, _y, _z;
                            const currentValue = (_w = accessorRef.current) === null || _w === void 0 ? void 0 : _w.get();
                            const retainedValue = Object.fromEntries(((_y = (_x = parameter.clipboard) === null || _x === void 0 ? void 0 : _x.retainKeys) === null || _y === void 0 ? void 0 : _y.map((key) => [
                                key,
                                currentValue === null || currentValue === void 0 ? void 0 : currentValue[key],
                            ])) || []);
                            const clipBoardData = yield paste();
                            if (!clipBoardData)
                                return;
                            (_z = accessorRef.current) === null || _z === void 0 ? void 0 : _z.set(Object.assign(Object.assign({}, clipBoardData), retainedValue));
                        }), variant: "primary", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u8CBC\u308A\u4ED8\u3051" },
                        react_1.default.createElement("i", { className: "mdi mdi-content-paste" })))),
                editModeEnabled && editMode && (react_1.default.createElement(components_1.Button, { style: { marginLeft: "5px" }, variant: "primary", onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        var _0;
                        const result = yield confirm({
                            message: "破棄しますか？",
                        });
                        if (!result)
                            return;
                        (_0 = accessorRef.current) === null || _0 === void 0 ? void 0 : _0.set(data);
                        setEditMode(undefined);
                    }), "data-tooltip-id": "tooltip", "data-tooltip-content": "\u7834\u68C4\u3057\u3066\u95B2\u89A7\u753B\u9762\u306B\u623B\u308B" },
                    react_1.default.createElement("i", { className: "mdi mdi-window-close" }))),
                editModeEnabled &&
                    !editMode &&
                    parameter.edit &&
                    !parameter.edit.isDisabled && (react_1.default.createElement(components_1.Button, { style: { marginLeft: "5px" }, variant: "primary", onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        setEditMode("1");
                    }), "data-tooltip-id": "tooltip", "data-tooltip-content": "\u7DE8\u96C6" },
                    react_1.default.createElement("i", { className: "mdi mdi-pencil" }))),
                !loading && parameter.tooltip && (react_1.default.createElement(react_1.default.Fragment, null,
                    " ",
                    react_1.default.createElement(components_1.Button, { variant: "primary", "data-tooltip-id": "tooltip-click", "data-tooltip-html": parameter.tooltip &&
                            `<div class="tooltip-content">${parameter.tooltip}</div>`, style: {
                            borderRadius: "50%",
                            width: "26px",
                            height: "26px",
                            padding: "0",
                        } },
                        react_1.default.createElement("span", { className: "mdi mdi-information-variant" })))),
                parameter.history && (react_1.default.createElement(components_1.Button, { style: { marginLeft: "5px" }, variant: "primary", onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        var _1;
                        navigate(((_1 = parameter.history) === null || _1 === void 0 ? void 0 : _1.path) || "");
                    }), "data-tooltip-id": "tooltip", "data-tooltip-content": "\u5C65\u6B74" },
                    react_1.default.createElement("i", { className: "mdi mdi-history" })))))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h1", { className: "title" }, parameter.title),
            react_1.default.createElement("h2", { className: "subtitle" }, parameter.subtitle)))),
        react_1.default.createElement("div", { style: { padding: "0 18px" } }, header),
        react_1.default.createElement("section", null,
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_1.Modal, { show: loading },
                    react_1.default.createElement(react_bootstrap_1.Modal.Header, null,
                        react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "\u8AAD\u307F\u8FBC\u307F\u4E2D\u3067\u3059")),
                    react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                        react_1.default.createElement("p", null, "\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044"))),
                react_1.default.createElement("div", { className: "stepper-container" }, parameter.steps.map((step, index) => (react_1.default.createElement("div", { key: index, className: `step-label ${index === currentStep ? "active" : ""} ${index < currentStep ? "completed" : ""}` },
                    react_1.default.createElement("div", { className: "step-number" }, index + 1),
                    react_1.default.createElement("div", { className: "step-title" }, step.title))))),
                react_1.default.createElement(SchemaFormPage_1.SchemaFormInternal, { schemaComponents: schemaComponents, data: data, parameter: currentParameter, readOnly: readOnly || (editModeEnabled && !editMode), accessorRef: accessorRef })))));
};
const createSchemaFormStepPage = (schemaComponents) => {
    return (props) => {
        return (react_1.default.createElement(SchemaFormStepPageInternal, Object.assign({}, props, { schemaComponents: schemaComponents })));
    };
};
exports.createSchemaFormStepPage = createSchemaFormStepPage;
